import { api } from './client';
import { handleApiError } from './errors';
import { URLSchema } from '../schemas/models';
import * as z from 'zod/mini';

export interface AreaCoordinates {
  viewport_width: number;
  viewport_height: number;
  percent_x: number;
  percent_y: number;
  percent_width: number;
  percent_height: number;
}

export interface CreateMonitorRequest {
  email: string;
  url: string;
  area_coordinates?: AreaCoordinates;
}

export interface DeleteMonitorResponse {
  message: string;
}

export const monitorApi = {
  /**
   * Create a new monitor
   * POST /api/monitors
   */
  async create(data: CreateMonitorRequest): Promise<z.infer<typeof URLSchema>> {
    
    try {
      const response = await api.post('monitors', { json: data }).json();
      return URLSchema.parse(response);
    } catch (error) {
      return await handleApiError(error);
    }
  },

  /**
   * Delete a monitor by ID
   * DELETE /api/monitors/:id?email=...
   */
  async delete(id: string, email: string): Promise<DeleteMonitorResponse> {
    try {
      const response = await api.delete(`monitors/${id}`, {
        searchParams: { email }
      }).json();
      return response as DeleteMonitorResponse;
    } catch (error) {
      return await handleApiError(error);
    }
  }
};